/**
 * 获取html2canvas转化工具
 */
export const getHTML2Canvas = () => {
    return import(/* webpackChunkName: "html2canvas" */ '@fx-ui/html2canvas').then(
        (html2Canvas) => {
            return html2Canvas.default;
        }
    );
};
